import { render, staticRenderFns } from "./GtyTag.vue?vue&type=template&id=0af088ab&scoped=true"
import script from "./GtyTag.vue?vue&type=script&lang=js"
export * from "./GtyTag.vue?vue&type=script&lang=js"
import style0 from "./GtyTag.vue?vue&type=style&index=0&id=0af088ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af088ab",
  null
  
)

export default component.exports